import { Facebook, Mail, MapPin, Phone } from "lucide-react";
import { BUSINESS, BRANCHES } from "@/lib/site-data";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="bg-maroon-deep text-cream/80 pt-20 pb-10 relative"
        >
            <div className="max-w-7xl mx-auto px-5 lg:px-10">
                <div className="grid md:grid-cols-12 gap-10 pb-14 border-b border-gold/20">
                    <div className="md:col-span-4">
                        <div className="flex items-center gap-3">
                            <span className="w-12 h-12 rounded-full bg-cream flex items-center justify-center text-maroon font-serif text-2xl border border-gold">
                                A
                            </span>
                            <div>
                                <div className="font-serif text-2xl text-cream">
                                    {BUSINESS.name}
                                </div>
                                <div className="text-[0.65rem] tracking-[0.25em] uppercase text-gold-light">
                                    {BUSINESS.tagline}
                                </div>
                            </div>
                        </div>
                        <p className="mt-6 text-sm font-light leading-relaxed text-cream/70 max-w-sm">
                            A small, family-run sanctuary for authentic Thai massage and wellness in
                            Cape Town. Two welcoming branches. One quiet promise — true relaxation.
                        </p>

                        <a
                            href={BUSINESS.facebook}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="footer-facebook"
                            className="mt-7 inline-flex items-center gap-3 text-sm text-gold-light hover:text-gold transition"
                        >
                            <span className="w-9 h-9 flex items-center justify-center rounded-full border border-gold/40 group-hover:bg-gold/10">
                                <Facebook size={14} />
                            </span>
                            Follow us on Facebook for updates & specials
                        </a>
                    </div>

                    {BRANCHES.map((b) => (
                        <div key={b.id} className="md:col-span-3">
                            <h4 className="font-serif text-xl text-gold-light">{b.name}</h4>
                            <p className="text-[0.65rem] tracking-[0.22em] uppercase text-cream/50 mt-1">
                                {b.label}
                            </p>
                            <ul className="mt-5 space-y-3 text-sm text-cream/75">
                                <li className="flex items-start gap-2">
                                    <MapPin size={14} className="text-gold mt-0.5 shrink-0" />
                                    {b.address}
                                </li>
                                <li className="flex items-start gap-2">
                                    <Phone size={14} className="text-gold mt-0.5 shrink-0" />
                                    {b.phone}
                                </li>
                                <li className="text-cream/55 text-xs tracking-widest uppercase pt-1">
                                    {b.hours}
                                </li>
                            </ul>
                        </div>
                    ))}

                    <div className="md:col-span-2">
                        <h4 className="font-serif text-xl text-gold-light">Contact</h4>
                        <ul className="mt-5 space-y-3 text-sm">
                            <li>
                                <a
                                    href={`mailto:${BUSINESS.email}`}
                                    className="flex items-center gap-2 text-cream/75 hover:text-gold-light transition"
                                >
                                    <Mail size={14} className="text-gold" />
                                    Email
                                </a>
                            </li>
                            <li>
                                <a
                                    href="#contact"
                                    className="text-cream/75 hover:text-gold-light transition"
                                >
                                    Booking form
                                </a>
                            </li>
                            <li>
                                <a
                                    href="#pricing"
                                    className="text-cream/75 hover:text-gold-light transition"
                                >
                                    Price list
                                </a>
                            </li>
                            <li>
                                <a
                                    href="#catering"
                                    className="text-cream/75 hover:text-gold-light transition"
                                >
                                    Catering & events
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="pt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs tracking-widest uppercase text-cream/45">
                    <span>© {new Date().getFullYear()} {BUSINESS.name}. All rights reserved.</span>
                    <span>Crafted with care · Cape Town</span>
                </div>
            </div>
        </footer>
    );
}
